export default __webpack_public_path__ + "static/client_back-fd4126ac175d987241fdd4c6952e5288.jpg";